// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
export class BaseGroupController {
    getItemName(type, key) {
        const itemNameKey = this.getItemNameKey(type);
        return Resources.getResource(itemNameKey);
    }
    getItemTooltip(type, key) {
        const itemNameKey = this.getItemNameKey(type);
        if (Resources.IsResourcePresent(itemNameKey + '.descr')) {
            return Resources.getResource(itemNameKey + '.descr');
        }
        return this.getItemName(type, key);
    }
    getItemNameKey(type) {
        return '';
    }
    getItemRule(type) {
        return null;
    }
    getItemGroupRule() {
        return null;
    }
}
